<script>
  import authService from '@/services/security/hosted-auth.service'

  export default {
    mounted() {
      authService.login()
    }
  }
</script>
